const module = { name: 'Fandango/dropdown', exports: {} }; const exports = module.exports;
const Styles = {
    CLOSE_BTN: 'fd-dropdown__close_btn',
    CONTAINER: 'fd-dropdown__container'
}
const KeyCodes = {
    ESC: 27
}
const Selectors = {
    ARIA_LIVE: '#js-aria-live',
    MOBILE_NAVIGATION: '.nav-bar',
}
const FOCUSABLE_ELEMENTS = [
    'a[href]',
    'input:not([disabled]):not([type="hidden"]):not([aria-hidden])',
    'select:not([disabled]):not([aria-hidden])',
    'textarea:not([disabled]):not([aria-hidden])',
    'button:not([disabled]):not([aria-hidden])',
    '[tabindex]:not([tabindex^="-"])'
].join(',')
let ariaLiveEl
function isWithinDropdown(target, dropdown, closeBtn, openerId) {
    const isDropdown = target === dropdown;
    const isChildElement = dropdown.contains(target);
    const isOpener = openerId && target === document.getElementById(openerId);
    const isCloseBtn = target === closeBtn;
    return isDropdown || isChildElement || isOpener || isCloseBtn;
}
function attachEvents(context) {
    function removeDropdown(restoreFocus) {
        context.closeBtn && context.closeBtn.remove();
        context.dropdown.removeEventListener('focusout', onDropdownFocusOut);
        context.dropdown.removeEventListener('keydown', onDropdownKeyDown);
        context.dropdown.remove();
        document.removeEventListener('click', onDocClick);
        document.removeEventListener('keydown', onDocKeyDown);
        if (ariaLiveEl) {
            ariaLiveEl.textContent = '';
        }
        const activeElement = context.activeElement;
        if (restoreFocus && activeElement && activeElement.focus) {
            activeElement.focus();
        }
        context.closeCB && context.closeCB();
    }
    function onDocKeyDown(e) {
        if (e.keyCode !== KeyCodes.ESC) {
            return;
        }
        if (!isWithinDropdown(e.target, context.dropdown, context.closeBtn, context.openParent)) {
            return;
        }
        removeDropdown(true);
    }
    function onDocClick(e) {
        if (isWithinDropdown(e.target, context.dropdown, context.closeBtn, context.openParent)) {
            return;
        }
        removeDropdown(false);
    }
    function onCloseBtnClick(e) {
        e.stopPropagation();
        removeDropdown(true);
    }
    function onDropdownFocusOut(e) {
        if (!context.dropdown.isConnected) {
            return;
        }
        if (!e.relatedTarget || !isWithinDropdown(e.relatedTarget, context.dropdown, context.closeBtn, null)) {
            removeDropdown(false);
        }
    }
    function onDropdownKeyDown(e) {
        if (e.code === 'Tab') {
            const focusableItems = [...context.dropdown.querySelectorAll(FOCUSABLE_ELEMENTS)];
            const focusedItemIndex = focusableItems.indexOf(document.activeElement);
            const lastFocusableItemIndex = focusableItems.length - 1;
            if (e.shiftKey) {
                if (focusedItemIndex === 0) {
                    focusableItems[lastFocusableItemIndex].focus();
                    e.preventDefault();
                }
            }
            else {
                if (focusedItemIndex === lastFocusableItemIndex) {
                    focusableItems[0].focus();
                    e.preventDefault();
                }
            }
        }
    }
    document.addEventListener('keydown', onDocKeyDown);
    document.addEventListener('click', onDocClick);
    context.closeEventListener && context.closeEventListener(removeDropdown.bind(this, true));
    context.closeBtn && context.closeBtn.addEventListener('click', onCloseBtnClick);
    context.dropdown.close = (restoreFocus = true) => removeDropdown(restoreFocus);
    if (context.trapFocus) {
        context.dropdown.addEventListener('keydown', onDropdownKeyDown);
    }
    else if (context.closeOnFocusOut) {
        context.dropdown.addEventListener('focusout', onDropdownFocusOut);
    }
}
function open(content, opts, cb) {
    opts = opts || {};
    const id = 'fd-dropdown-' + (opts.name || Date.now());
    if (document.querySelector('#' + id)) {
        return;
    }
    const dropdown = document.createElement('aside');
    dropdown.id = id;
    dropdown.setAttribute('class', `${Styles.CONTAINER} ${opts.dropdownStyle || ''}`);
    opts.trapFocus !== false && dropdown.setAttribute('role', 'dialog');
    if (typeof content === 'string') {
        dropdown.innerHTML = content;
    }
    else {
        dropdown.appendChild(content);
    }
    let closeBtn;
    if (opts.includeCloseBtn !== false) {
        closeBtn = document.createElement('button');
        closeBtn.setAttribute('class', `${Styles.CLOSE_BTN} ${opts.closeBtnStyle || ''}`);
        closeBtn.dataset.overlayID = id;
        closeBtn.innerHTML = 'Cancel';
    }
    const activeElement = document.activeElement;
    let parent = document.body;
    if (opts.relativeParent) {
        if (typeof opts.relativeParent === 'string') {
            parent = document.querySelector(opts.relativeParent) || parent;
        }
        else {
            parent = opts.relativeParent;
        }
    }
    if (opts.screenReaderText) {
        ariaLiveEl = document.querySelector(Selectors.ARIA_LIVE);
        if (ariaLiveEl) {
            ariaLiveEl.textContent = opts.screenReaderText;
        }
    }
    if (!window.Fandango?.context?.device?.isMobile) {
        parent.appendChild(dropdown);
    }
    else {
        const screenClientRect = document.body.getBoundingClientRect();
        const navBar = document.querySelector(Selectors.MOBILE_NAVIGATION);
        const navBarTop = navBar?.getBoundingClientRect().top;
        parent.appendChild(dropdown);
        const prospectiveClientRect = dropdown.getBoundingClientRect();
        const excessBoundsX = prospectiveClientRect.right - screenClientRect.right;
        const excessBoundsY = prospectiveClientRect.bottom - (navBarTop ?? screenClientRect.bottom);
        if ((excessBoundsX > 0) || (excessBoundsY > 0)) {
            const adjustmentUnitsX = excessBoundsX > 0 ? `-${excessBoundsX}px` : '0';
            const adjustmentUnitsY = excessBoundsY > 0 ? `-${excessBoundsY}px` : '0';
            dropdown.style.transform = `translate(${adjustmentUnitsX}, ${adjustmentUnitsY})`;
        }
    }
    if (closeBtn) {
        let localCloseBtnParent, globalCloseBtnParent;
        if (opts.closeBtnParent) {
            localCloseBtnParent = dropdown.querySelector(opts.closeBtnParent);
            if (!localCloseBtnParent) {
                globalCloseBtnParent = document.querySelector(opts.closeBtnParent);
            }
        }
        const closeBtnParent = localCloseBtnParent ?? globalCloseBtnParent ?? dropdown;
        closeBtnParent.appendChild(closeBtn);
        closeBtn.focus();
    }
    window.requestAnimationFrame(() => {
        const context = {
            closeBtn,
            dropdown,
            openParent: opts.openParent,
            activeElement,
            closeEventListener: opts.closeEventListener,
            closeCB: opts.closeCB,
            trapFocus: opts.trapFocus !== false,
            closeOnFocusOut: opts.closeOnFocusOut,
        };
        attachEvents(context);
        opts.openCB && opts.openCB();
        if (opts.openAsync) {
            return cb(dropdown);
        }
    });
    if (!opts.openAsync) {
        return dropdown;
    }
}
function close(name) {
    const id = `fd-dropdown-${name}`;
    document.getElementById(id)?.remove();
}
function extendLegacy(area, publicInterface) {
    window.Fandango = window.Fandango || {};
    const { Fandango } = window;
    if (!Fandango[area]) {
        Fandango[area] = publicInterface;
    }
}
module.exports = {
    close,
    open,
    openAsync(markup, opts, cb) {
        open(markup, Object.assign(opts || {}, {
            openAsync: true
        }), cb);
    }
};
extendLegacy('dropdown', module.exports);
export default module.exports;